import { render } from "./CeremonieAcademique.vue?vue&type=template&id=0d9ddf2b&scoped=true&ts=true"
import script from "./CeremonieAcademique.vue?vue&type=script&lang=ts"
export * from "./CeremonieAcademique.vue?vue&type=script&lang=ts"

import "./CeremonieAcademique.vue?vue&type=style&index=0&id=0d9ddf2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9ddf2b"]])

export default __exports__